export class UpdateRoomReservationsDto {
  rooms: {
    [index: string]: boolean;
  };
}
